import EmissionValueWithSuffix from '../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { PCFBiogenicEmissionsMode } from '../../../shared/enums/pcf';
import { IComponent } from '../../../shared/interfaces/IComponent';
import { EmissionSymbol } from '../../../shared/interfaces/IFootprint';

type ComponentPcfValueProps = {
  component: IComponent;
  biogenicEmissionsMode: PCFBiogenicEmissionsMode;
};

const ComponentPcfValue = ({
  component,
  biogenicEmissionsMode,
}: ComponentPcfValueProps): JSX.Element | null => {
  const value =
    biogenicEmissionsMode === PCFBiogenicEmissionsMode.Include
      ? component.pcfIncluding
      : component.pcfExcluding;

  if (value == null) {
    return null;
  }

  return (
    <EmissionValueWithSuffix
      emissionValue={value}
      emissionSymbol={EmissionSymbol.KG_CO2E}
      declaredUnit={component.declaredUnit}
      abbreviateUnit
      unitaryProductAmount={component.unitaryProductAmount}
    />
  );
};

export default ComponentPcfValue;
